import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import OperatorLogoSrc from '../../asset/svg/umOperatorLogo.svg';
import RevisionDetail from './common/revisionDetail/revisionDetail';
import './login.scss';

export default class LoginContainer extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired,
        onEnterKeydown: PropTypes.func
    };

    constructor (props) {
        super(props);

        this.onKeydown = this.onKeydown.bind(this);
    }

    onKeydown (event) {
        const enterKeyCode = 13;

        if (event.keyCode === enterKeyCode) {
            this.props.onEnterKeydown();
        }

        event.stopPropagation();
    }

    componentDidMount () {
        document.addEventListener('keydown', this.onKeydown, false);
    }

    componentWillUnmount () {
        document.removeEventListener('keydown', this.onKeydown, false);
    }

    render () {
        const {
            className,
            children
        } = this.props;

        return (
            <div className={classNames('loginComponent ' + className)}>

                <div className="loginContainer">

                    <img className="guidewireLogo"
                         src={OperatorLogoSrc}/>

                    {children}

                    <RevisionDetail/>
                </div>
            </div>
        );
    }
}

